import { DealDto } from "@/shared/swagger/client/api-client";
import { forwardRef } from "react";

type VDPProps = {
  initType?: string | null;
  data: DealDto;
};

export const VDP = forwardRef<HTMLDivElement, VDPProps>(
  ({ initType, data }, ref) => {
    const title = `${data.year} ${data.make} ${data.model}`;

    return (
      <div className="container" ref={ref}> 
        <h3 style={{ color: '#136aaf' }}>{initType === 'seller' ? 'Seller' : 'Buyer'}</h3>
        <div className="header">{data?.title ? data.title : `${data.year} ${data.make} ${data.model}`}</div>
        <div className="sub-header">{data.mileage} miles</div>
        <div className="content">
            <div>
                <img className="car-image" src={data?.primaryImage} alt={title} />
                <div className="gallery">
                    <img src={data?.primaryImage} alt={title} />
                    <img src={data?.primaryImage} alt={title} />
                    <img src={data?.primaryImage} alt={title} />
                </div>
            </div>
            <div className="wrapper">
                <div className="price">${data?.price}</div>
                <div id="offer-chat"></div>
                <div className="contact">
                    <strong>Contact the Dealer</strong><br /><br />
                    <button>Call +1 (786) 772-2422</button>
                </div>
            </div>
        </div>
        <h3>Vehicle Description</h3>
        <p className="description">The Lamborghini Aventador Ultimae signifies the final production run for the legendary Lamborghini Aventador. One of the most popular poster-cars of the modern era. Taking the key components from the record-breaking SVJ and combining them with a much more refined, street-oriented Aventador, the Ultimae is quite literally the ultimate...</p>
      </div>
    );
  }
);

// Add display name for debugging purposes
VDP.displayName = 'VDP';